import { render } from "./BookModal.vue?vue&type=template&id=1ccbb760&scoped=true"
import script from "./BookModal.vue?vue&type=script&lang=js"
export * from "./BookModal.vue?vue&type=script&lang=js"

import "./BookModal.vue?vue&type=style&index=0&id=1ccbb760&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccbb760"]])

export default __exports__